export const ADMIN_PASSWORD = 'secret'; 
export const API_URL = process.env.REACT_APP_API_URL || 'https://proto-backend-d2c1638486b9.herokuapp.com/';